import { Layout, Page, usePath } from "@fdoh/health-ui-react";
import { useData } from "../../hooks";
import { useHistory, useLocation } from "react-router-dom";
import FillExcavationMaterialForm from "../Components/FillExcavationMaterialForm";
import { FillExcavationMaterialInput } from "../Components/FillExcavationMaterialForm.types";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";

const EditFillExcavationPage = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');
    const path = usePath();
    const data = useData<FillExcavationMaterialInput>(path.current);
  return data && applicationId ? (
    <Page.Container>
      <ApplicationDetailsPage id={applicationId}></ApplicationDetailsPage>      
      <Page.Body>
        <Layout.Container>
          <FillExcavationMaterialForm
            id="editFillExcavationMaterialForm"
            title="Fill Excavation Materials Inspection"
            action="post"
                      applicationInspectionId={data?.applicationInspectionId}
                      applicationId={applicationId}
                      returnPath={`/inspectionDetails/${inspectionId}`}
            values={data}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <div>
    
  </div>;
};

export default EditFillExcavationPage;